import React from "react";
import _ from "lodash";
import { gql } from "@apollo/client";
import EventGroupListItem from "./EventGroupListItem";

const EventGroupList = ({ eventGroups, locationFilter = null }) => {
  eventGroups = _.sortBy(
    eventGroups.filter((eg) => eg.items.length > 0),
    (eg) => eg.items[0].dateTime
  );

  return (
    <div>
      {eventGroups.map((eventGroup) => (
        <EventGroupListItem
          key={eventGroup.id}
          eventGroup={eventGroup}
          locationFilter={locationFilter}
        />
      ))}
    </div>
  );
};

EventGroupList.fragments = {
  eventGroup: gql`
    fragment EventGroupListEventGroup on EventGroup {
      id
      ...EventGroupListItemEventGroup
    }
    ${EventGroupListItem.fragments.eventGroup}
  `,
};

export default EventGroupList;
